import { getCurrentScreen } from './currentScreen'

const MAX_KEY_MESSAGE_LENGTH = 200
const XPCOM_LOCATION = /\s*location:\s*"[^"]*"/g
const WHITESPACE = /\s+/g

const loggedKeys = new Set<string>()

const normalizeMessage = (message: string) =>
    message
        .replace(XPCOM_LOCATION, '')
        .replace(WHITESPACE, ' ')
        .trim()
        .slice(0, MAX_KEY_MESSAGE_LENGTH)

export const shouldLogError = (kind: string, message: string): boolean => {
    const key = `${kind}|${getCurrentScreen()}|${normalizeMessage(message)}`

    if (loggedKeys.has(key)) {
        return false
    }

    loggedKeys.add(key)

    return true
}

export const resetErrorLogGuard = () => {
    loggedKeys.clear()
}
